// The visual signature of the app: an incoming Wilman transmission.
// Mono header, serif body, italic signature. The wilman_text is rendered
// VERBATIM from challenges.json — no paraphrasing, no reformatting.

import VoicePlayer from './VoicePlayer.jsx';
import { cleanWilmanText } from '../lib/wilmanText.js';

export default function TransmissionCard({ transmission, children }) {
  if (!transmission) return null;
  const { challenge_title, challenge_text, points_base, bonus_modifiers, audience, deadline_strategy, fired_at, audio_url, audio_duration } = transmission;

  return (
    <article className="card overflow-hidden border-l-4 border-l-copper">
      <header className="border-b border-border-tertiary bg-bg-secondary px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-fg-tertiary">
        <div className="flex items-baseline justify-between gap-2">
          <span>incoming transmission</span>
          <span>{relativeTime(fired_at)}</span>
        </div>
        <p className="mt-1 truncate text-fg-secondary">subject: {challenge_title.toLowerCase()}</p>
      </header>

      <div className="space-y-4 px-4 py-4">
        <p className="font-serif text-lg leading-relaxed text-fg-primary">{cleanWilmanText(challenge_text)}</p>

        {audio_url && <VoicePlayer url={audio_url} duration={audio_duration} label="play transmission" />}

        <div className="space-y-1 font-mono text-[11px] uppercase tracking-wider text-fg-tertiary">
          {points_base != null && (
            <p>
              base · <span className="text-fg-secondary">{points_base} pts</span>
            </p>
          )}
          {Array.isArray(bonus_modifiers) && bonus_modifiers.length > 0 && (
            <ul className="space-y-0.5">
              {bonus_modifiers.map((b) => (
                <li key={b.condition}>
                  bonus · <span className="text-fg-secondary">+{b.points}</span>
                  <span className="ml-1 normal-case tracking-normal text-fg-tertiary">
                    if {b.condition.replace(/_/g, ' ')}
                  </span>
                </li>
              ))}
            </ul>
          )}
          {deadline_strategy && (
            <p>
              deadline · <span className="text-fg-secondary">{deadline_strategy.replace(/_/g, ' ')}</span>
            </p>
          )}
          {audience && audience !== 'all_players' && (
            <p>
              audience · <span className="text-fg-secondary">{Array.isArray(audience) ? audience.join(', ') : audience}</span>
            </p>
          )}
        </div>

        {children}

        <p className="font-serif italic text-sm text-fg-tertiary">— Mr. Wilman</p>
      </div>
    </article>
  );
}

function relativeTime(iso) {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return '';
  if (ms < 60_000) return 'just now';
  const min = Math.floor(ms / 60_000);
  if (min < 60) return `${min}m ago`;
  const hrs = Math.floor(min / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}
